module.exports = __webpack_public_path__ + "img/sports_top.a95305d6.jpg";